var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChatTeardropDots(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 34,
    viewBox: "0 0 32 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 28.2336H5.96251C5.83564 28.2354 5.70973 28.2106 5.5922 28.1606C5.47466 28.1106 5.36789 28.0366 5.27817 27.9428C5.18846 27.849 5.11762 27.7373 5.06985 27.6144C5.02207 27.4915 4.99833 27.3598 5.00001 27.2272V16.2082C5.00001 13.0189 6.21161 9.96014 8.36828 7.70493C10.5249 5.44972 13.45 4.18276 16.5 4.18276V4.18276C18.0102 4.18276 19.5056 4.49381 20.9009 5.09814C22.2961 5.70248 23.5639 6.58827 24.6317 7.70493C25.6996 8.8216 26.5467 10.1473 27.1246 11.6063C27.7026 13.0653 28 14.629 28 16.2082V16.2082C28 17.7874 27.7026 19.3511 27.1246 20.8101C26.5467 22.2691 25.6996 23.5948 24.6317 24.7115C23.5639 25.8281 22.2961 26.7139 20.9009 27.3183C19.5056 27.9226 18.0102 28.2336 16.5 28.2336V28.2336Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 17.7767C17.0523 17.7767 17.5 17.3086 17.5 16.731C17.5 16.1535 17.0523 15.6854 16.5 15.6854C15.9477 15.6854 15.5 16.1535 15.5 16.731C15.5 17.3086 15.9477 17.7767 16.5 17.7767Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 17.7767C11.0523 17.7767 11.5 17.3086 11.5 16.731C11.5 16.1535 11.0523 15.6854 10.5 15.6854C9.94772 15.6854 9.5 16.1535 9.5 16.731C9.5 17.3086 9.94772 17.7767 10.5 17.7767Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 17.7767C23.0523 17.7767 23.5 17.3086 23.5 16.731C23.5 16.1535 23.0523 15.6854 22.5 15.6854C21.9477 15.6854 21.5 16.1535 21.5 16.731C21.5 17.3086 21.9477 17.7767 22.5 17.7767Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatTeardropDots);
export default __webpack_public_path__ + "static/media/ChatTeardropDots.930e4147a55429e06317c7e1be594fb4.svg";
export { ForwardRef as ReactComponent };